module.exports = __webpack_public_path__ + "static/media/main_small_5.cc031fd2.png";